"use client";
import { jsx as e } from "react/jsx-runtime";
import { memo as l } from "react";
import t from "../components/Icon/SvgIcon.js";
const c = (o) => /* @__PURE__ */ e(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ e(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.88 2H5.12A3.12 3.12 0 0 0 2 5.12v13.76A3.12 3.12 0 0 0 5.12 22h13.76A3.12 3.12 0 0 0 22 18.88V5.12A3.12 3.12 0 0 0 18.88 2m-.663 7.457L11.12 16.56a.72.72 0 0 1-1.018.022L6 12.48a.72.72 0 0 1-.022-1.018L7.2 10.24a.72.72 0 0 1 1.018-.022l2.422 2.422L16 7.28c.275-.287.7-.335.981-.055L18.21 8.46c.317.35.277.722.007.997",
        clipRule: "evenodd"
      }
    )
  }
), i = l(c);
export {
  i as CheckboxSelected,
  i as default
};
